import config from "config";
import { APICore } from "helpers/api/apiCore";
import { FilterMetadata } from "redux/types";

const api = new APICore();

function fetchAllDailyBalanceApi(params: any) {
  const baseUrl = `${config.EOD_BASE_URL}/instrument-balances`;
  return api.get(`${baseUrl}`, params);
}

function fetchDailyBalanceApi(params: any) {
  const baseUrl = `${config.EOD_BASE_URL}/instrument-balances/${decodeURI(params)}`;
  return api.get(`${baseUrl}`, params);
}

export { fetchAllDailyBalanceApi, fetchDailyBalanceApi };
